import moment from "moment";

const nextMonth = (date) => {
  const passYear = date.getMonth() === 11;
  const newMonth = passYear ? 0 : date.getMonth() + 1;
  const year = passYear ? date.getFullYear() + 1 : date.getFullYear();
  return new Date(year, newMonth, 1);
};

const prevMonth = (date) => {
  const passYear = date.getMonth() === 0;
  const newMonth = passYear ? 11 : date.getMonth() - 1;
  const year = passYear ? date.getFullYear() - 1 : date.getFullYear();
  return new Date(year, newMonth, 1);
};

const validateDateRange = (newDate, min, max) => {
  const maxDate = new Date(max);
  const minDate = new Date(min);

  if (max && moment(newDate).isAfter(maxDate)) {
    return maxDate;
  }

  if (min && moment(newDate).isBefore(minDate)) {
    return minDate;
  }

  return newDate;
};

const localeData = (options) => {
  const defaultLocale = {
    direction: "ltr",
    format: moment.localeData().longDateFormat("L"),
    separator: " - ",
    applyLabel: "label_datePicker_apply",
    cancelLabel: "label_datePicker_cancel",
    weekLabel: "W",
    customRangeLabel: "Custom Range",
    daysOfWeek: moment.weekdaysMin(),
    monthNames: moment.monthsShort(),
    firstDay: moment.localeData().firstDayOfWeek(),
  };

  return { ...defaultLocale, ...options };
};

const yearMonth = (date) => {
  const month = date.getMonth() + 1;
  return date.getFullYear() + (month < 10 ? "0" : "") + month;
};

export { nextMonth, prevMonth, validateDateRange, localeData, yearMonth };
